import { Component, Injector } from '@angular/core';
import { AddInfoCategoryService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-add-info-category',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class AddInfoCategoryComponent extends BaseGridComponent {

  public descMaxLength: number = null;
  public displayOrderMax: number = null;
  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: AddInfoCategoryService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.descMaxLength = 100;
    this.displayOrderMax = 5;
    this.appCardTitle = 'Additional Information Categories';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Description',
      },
      {
        field: 'DisplayOrder',
        title: 'Display Order',
        editor: 'number',
        filter: 'numeric',
      },
      {
        field: 'IsRequired',
        title: 'Required',
        editor: 'boolean',
        filter: 'boolean'
      },
      {
        field: 'IsActive',
        title: 'Active',
        filter: 'boolean',
        editor: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
      DisplayOrder: ['', Validators.compose([Validators.required, Validators.pattern('[0-9]*'), Validators.max(99999)])],
      IsRequired: [],
      IsActive: [],
    });
  }
}
